/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { gql } from '@apollo/client';
import mbpLogger from 'mbp-logger';
import { Query } from '@apollo/client/react/components';
import {
    number, string, shape,  arrayOf,
    bool,

} from 'prop-types';
import { GRAPHQL_ENV } from '../../../../../../gql';
import GraphqlPortalLoader from '../../../../GraphqlCommonComponents/GraphqlPortalLoader';
import AddonV3 from './AddonV3';

function AddOnDescription({
    addonsData,
    brand,
    isPdpRedesignEnabled,
}) {
    const addonsPartNumbers = [];
    addonsData?.forEach((addonGroup) => {
        addonGroup.addons.forEach((addonitem) => {
            addonsPartNumbers.push(`"${addonitem.partNumber}"`);
        });
    });

    const partNumbers = `[${addonsPartNumbers.toString()}]`;
    const ADD_ONS_DESC_QUERY = gql`
    query PDPpageQuery {
        findSkuByPartNumbers(brand: "${brand?.domain}", environment: "${GRAPHQL_ENV}", partNumbers: ${partNumbers})
        {
            shortDescription, longDescription, partNumber
        }
       }
    `;

    return (
        <Query query={ADD_ONS_DESC_QUERY}>
            {({ loading, error, data }) => {
                if (loading) return <GraphqlPortalLoader />;
                if (error) {
                    mbpLogger.logError({
                        appName: process.env.npm_package_name,
                        query: ADD_ONS_DESC_QUERY,
                        component: 'AddonDescBuilder.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }
                if (!data) {
                    mbpLogger.logWarning({
                        appName: process.env.npm_package_name,
                        query: ADD_ONS_DESC_QUERY,
                        component: 'AddonDescBuilder.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }

                if (!data?.findSkuByPartNumbers) {
                    return null;
                }
                let addonData = addonsData;
                if (data?.findSkuByPartNumbers?.length > 0) {
                    addonData = addonData.map((addonGroup) => {
                    // Clone so can manipulate
                        const customAddonWithDesc = { ...addonGroup };
                        customAddonWithDesc.addons = addonGroup?.addons?.map((addonitem) => {
                        // Clone so can manipulate
                            const addon = { ...addonitem };
                            const addonDescObj = data?.findSkuByPartNumbers?.find((addonDesc) => addonDesc.partNumber === addonitem.partNumber);
                            addon.shortDescription = addonDescObj?.shortDescription;
                            addon.longDescription = addonDescObj?.longDescription;
                            return addon;
                        });
                        return customAddonWithDesc;
                    });
                }
                return (
                    <AddonV3
                        addonGroups={addonData}
                        brand={brand}
                        isPdpRedesignEnabled={isPdpRedesignEnabled}
                    />
                );
            }}
        </Query>
    );
}

AddOnDescription.propTypes = {
    addonsData: arrayOf(shape({
        name: string.isRequired,
        maxAllowedAddons: number.isRequired,
        addons: arrayOf(shape({
            id: string.isRequired,
            shortDescription: string,
            name: string.isRequired,
        })),
    })).isRequired,
    brand: shape({
        domain: string,
    }).isRequired,
    isPdpRedesignEnabled: bool,
};
AddOnDescription.defaultProps = {
    isPdpRedesignEnabled: false,

};
export default AddOnDescription;
